(function () {
  'use strict';

  /**
   * Accordion — smooth slide animation using max-height transitions.
   *
   * Opening:
   *   1. Remove hidden state, set maxHeight = scrollHeight (in px)
   *   2. After transitionend → set maxHeight = 'none' so content can grow
   *
   * Closing:
   *   1. Capture current scrollHeight, set it explicitly
   *   2. Force browser reflow to register the value
   *   3. Set maxHeight = '0' — CSS transition takes over
   *
   * This approach avoids jQuery while giving identical smoothness.
   */

  function initAccordion(section) {
    var items = section.querySelectorAll('[data-accordion-item]');

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-accordion-trigger]');
      var answer  = item.querySelector('[data-accordion-answer]');

      if (!trigger || !answer) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        if (isOpen) {
          closeItem(item, answer, trigger);
        } else {
          openItem(item, answer, trigger);
        }
      });

      // Keyboard: Enter / Space already fire click on <button>.
      // Additional keyboard support for arrow keys (optional a11y).
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          focusNextTrigger(section, trigger);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          focusPrevTrigger(section, trigger);
        }
      });
    });
  }

  /* ── Open ──────────────────────────────────────────────────── */
  function openItem(item, answer, trigger) {
    item.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    answer.setAttribute('aria-hidden', 'false');

    // Transition from 0 → scrollHeight
    answer.style.maxHeight = answer.scrollHeight + 'px';

    // After the transition, lift the hard cap so content can grow
    answer.addEventListener('transitionend', function onEnd(e) {
      // Only react to the max-height transition, not visibility
      if (e.propertyName !== 'max-height') return;
      if (item.classList.contains('is-open')) {
        answer.style.maxHeight = 'none';
      }
      answer.removeEventListener('transitionend', onEnd);
    });
  }

  /* ── Close ─────────────────────────────────────────────────── */
  function closeItem(item, answer, trigger) {
    item.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    answer.setAttribute('aria-hidden', 'true');

    // If maxHeight is 'none' (fully open), we must first set an
    // explicit px value so the browser can animate away from it.
    if (answer.style.maxHeight === 'none' || answer.style.maxHeight === '') {
      answer.style.maxHeight = answer.scrollHeight + 'px';
    }

    // Force the browser to register the explicit value (reflow).
    // Without this the transition from px → 0 doesn't trigger.
    // eslint-disable-next-line no-unused-expressions
    answer.offsetHeight;

    // Now animate to closed.
    answer.style.maxHeight = '0';
  }

  /* ── Arrow-key focus helpers ───────────────────────────────── */
  function getAllTriggers(section) {
    return Array.from(section.querySelectorAll('[data-accordion-trigger]'));
  }

  function focusNextTrigger(section, current) {
    var triggers = getAllTriggers(section);
    var idx = triggers.indexOf(current);
    var next = triggers[idx + 1];
    if (next) next.focus();
  }

  function focusPrevTrigger(section, current) {
    var triggers = getAllTriggers(section);
    var idx = triggers.indexOf(current);
    var prev = triggers[idx - 1];
    if (prev) prev.focus();
  }

  /* ── Boot ──────────────────────────────────────────────────── */
  function boot() {
    var sections = document.querySelectorAll('.accordion-section');
    sections.forEach(initAccordion);
  }

  // Initialise on DOMContentLoaded; also re-init on Shopify
  // theme-editor section:load events (live preview in customiser).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.accordion-section');
    if (section) initAccordion(section);
  });

})();
